module.exports = __webpack_public_path__ + "img/コザマル・カ.4807ae3b.png";